import { render, staticRenderFns } from "./OnlinePayments.vue?vue&type=template&id=2de43ba1&"
import script from "./OnlinePayments.vue?vue&type=script&lang=js&"
export * from "./OnlinePayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports